import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import * as XLSX from "xlsx";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCompraCreateInt() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;

  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("6633d63143ef7d22b847995d");
  const [programacion, setProgramacion] = useState("No");

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [fecha, setFecha] = useState("");
  const [plazo, setPlazo] = useState(0);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [fecha_puerto_est, setFechaPuertoEst] = useState("");
  const [fecha_entrega_est, setFechaEntregaEst] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_kilos, setTotalKilos] = useState(0);
  const [total_metros, setTotalMetros] = useState(0);
  const [tipoCambioEstimado, setTipoCambioEstimado] = useState(0);
  const [totalCaptura, setTotalCaptura] = useState(1);
  const [noOrdenProveedor, setNoOrdenProveedor] = useState("");


  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      unidad: "",
      colores: "",
      arrayColoresArticulo:[],
      cantidad: 0,
      precio: 0,
      total: 0,
      descuento:0,
      CBM: 0
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_PROVEEDORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      await axios
        .post(
          URL_ORDENES_COMPRA,
          {
            fecha,
            proveedores: selectedProveedor,
            clientes: selectedCliente,
            plazo,
            fecha_compromiso,
            fecha_puerto_est,
            fecha_entrega_est,
            total_general,
            observaciones,
            total_kilos,
            total_metros,
            autorizado: "Si",
            tipo:"Internacional",
            noOrdenProveedor,
            tipoCambioEstimado,
            programacion
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          inputFields.map((a) => {
            axios.post(
              URL_ARTICULOS_OC,
              {
                ordenesCompra: data.data._id,
                articulos: a.articulos,
                colores: a.colores,
                cantidad: parseFloat(a.cantidad),
                embarcado: 0,
                pendiente_embarcar: parseFloat(a.cantidad),
                precio: parseFloat(a.precio),
                total: parseFloat(a.total),
                recibido: 0,
                pendiente_recibir: 0,
                descuento: 0,
                CBM: a.CBM
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
          });
          axios.post(
            URL_LOGS,
            {
              tipo: "Crear Orden de Compra",
              detalle: `${selectedProveedor} ${total_general}`,
              user: user.id,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          );
          Swal.fire("Good job!", "Creado con exito", `success`);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length-1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        unidad: ultimo.unidad,
        colores: ultimo.colores,
        arrayColoresArticulo: ultimo.arrayColoresArticulo,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
        descuento:0,
        CBM: 0
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let mts = values.filter(e=>e.unidad == "Metros")
    let totalMts = mts.map((c) => parseFloat(c.cantidad));
    let TM = totalMts.reduce((t, total, index) => t + total, 0);
    setTotalMetros(TM);
    let KG = values.filter(e=>e.unidad == "Kilos")
    let totalKG = KG.map((c) => parseFloat(c.cantidad));
    let TK = totalKG.reduce((t, total, index) => t + total, 0);
    setTotalKilos(TK);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };

  function BuscaArticulo(id, event){
    articulos.map((a)=>{
      if(a._id == event.target.value){
        let idArticulo = a._id
        let unidadArticulo = a.unidad
        let coloresArticulo = a.colores
        handleChangeInputArticulo(id, idArticulo, unidadArticulo, coloresArticulo)
      }
    })
  }

  const handleChangeInputArticulo = (id, idArticulo, unidadArticulo, coloresArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.unidad = unidadArticulo
        i.arrayColoresArticulo = coloresArticulo
        let totalParcial = i.cantidad * i.precio;
        i.total = (totalParcial - (totalParcial * i.descuento) / 100).toFixed(2);
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales()
  };


  function ActualizaTotales(){
        let mts = inputFields.filter(e=>e.unidad == "Metros")
        let totalMts = mts.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        setTotalMetros(TM);
        let KG = inputFields.filter(e=>e.unidad == "Kilos")
        let totalKG = KG.map((c) => parseFloat(c.cantidad));
        let TK = totalKG.reduce((t, total, index) => t + total, 0);
        setTotalKilos(TK);
        let importes = inputFields.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneral(TG);
  }

  // function importarArchivo(event){
  //   const target = event.target;
  //   const value = target.type === "checkbox" ? target.checked : target.value;
  //   const name = target.name;
  //   let hojas = [];
   
  //   if (name === "file") {
  
  //     let reader = new FileReader();
  //       reader.readAsArrayBuffer(target.files[0]);
  //       reader.onloadend = (e) => {
  //         var data = new Uint8Array(e.target.result);
  //         var workbook = XLSX.read(data, { type: "array" });
  
  //         workbook.SheetNames.forEach(function (sheetName) {
  //           // Here is your object
  //           var XL_row_object = XLSX.utils.sheet_to_json(
  //             workbook.Sheets[sheetName]
  //           );
  //           hojas.push({
  //             data: XL_row_object,
  //             sheetName,
  //           });
  //         });
  
  //         let A1 = hojas[0].data
  
  //         let TC = totalCaptura
  //         A1.map((a)=>{
  //            TC = TC + 1
  //           setTotalCaptura(TC)
  //         inputFields.push({
  //           id: uuidv4(),
  //           articulos: a.articulos,
  //          unidad: a.unidad,
  //          colores: a.colores,
  //          cantidad: a.cantidad,
  //          precio: 0,
  //          descuento: 0,
  //          total: 0,
  //         })
  //         })
  
  //         ActualizaTotales()
  //       }
  //   }
  // }
  // console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.oc_create ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Orden de Compra</h3>
          <Form onSubmit={saveOrdenCompra}>
            <Row>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                    let inicio = new Date(e.target.value)
                    let compromiso = inicio.setDate(inicio.getDate()+45);
                    setFechaCompromiso(moment(compromiso).format("YYYY-MM-DD"))
                    let puerto = inicio.setDate(inicio.getDate()+30);
                    setFechaPuertoEst(moment(puerto).format("YYYY-MM-DD"))
                    let entrega = inicio.setDate(inicio.getDate()+15);
                    setFechaEntregaEst(moment(entrega).format("YYYY-MM-DD"))
                  }}
                />
              </Col>
              <Col md={3}>
                <Label className="mr-sm-2">Proveedor</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedProveedor}
                  required
                  onChange={(e) => {
                    setSelectedProveedor(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Proveedor</option>
                  {proveedores
                    .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre_comercial}</option>;
                    })}
                </Input>
              </Col>
              <Col md={1}>
                <Label>Plazo</Label>
                <Input
                  type="text"
                  placeholder="Plazo"
                  value={plazo}
                  required
                  onChange={(e) => {
                    setPlazo(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Compromiso</Label>
                <Input
                  type="date"
                  placeholder="Fecha Compromiso"
                  value={fecha_compromiso}
                  required
                  onChange={(e) => {
                    setFechaCompromiso(e.target.value);
                  }}
                />
              </Col>

            <Col md={2}>
                <Label>Fecha Puerto Est.</Label>
                <Input
                  type="date"
                  value={fecha_puerto_est}
                  required
                  onChange={(e) => {
                    setFechaPuertoEst(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Fecha Entrega Est.</Label>
                <Input
                  type="date"
                  value={fecha_entrega_est}
                  required
                  onChange={(e) => {
                    setFechaEntregaEst(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label># Orden Proveedor</Label>
                <Input
                  type="text"
                  placeholder="Orden Proveedor"
                  value={noOrdenProveedor}
                  required
                  onChange={(e) => {
                    setNoOrdenProveedor(e.target.value);
                  }}
                />
              </Col>
              <Col md={1}>
                <Label>T.C. Estimado</Label>
                <Input
                  type="number"
                  value={tipoCambioEstimado}
                  required
                  onChange={(e) => {
                    setTipoCambioEstimado(e.target.value);
                  }}
                />
              </Col>

              <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label>Programacion</Label>
              <Input
              type="select"
              value={programacion}
              required
              onChange={(e) => {
                setProgramacion(e.target.value);
              }}
              >
              <option value="">Selecciona</option>
              <option value="Si">Si</option>
              <option value="No">No</option>
              </Input>
              </Col>
              {programacion == "Si" ? (
                  <Col md={3}>
                  <Label className="mr-sm-2">Cliente</Label>
                  <Input
                    className="col-sm-12"
                    type="select"
                    value={selectedCliente}
                    required
                    onChange={(e) => {
                      setSelectedCliente(e.target.value);
                    }}
                  >
                    <option value="0">Selecciona un Cliente</option>
                    {clientes
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.nombre_comercial}</option>;
                      })}
                  </Input>
                </Col>
              ):undefined}
              {/* <Col md={3}>
              <h4 id="logoutBoton">
              TOTALES {total_kilos} kg. / {total_metros} mts. / {"$" + new Intl.NumberFormat("en-US").format(total_general)}
              </h4>
              </Col> */}
              </Row>
              {/* <Row>
              <Col>
                    <Input
                      required
                      type="file"
                      name="file"
                      id="file"
                      onChange={(event) =>
                        importarArchivo(event)
                      }
                    />
                    </Col>
              </Row> */}

            {/* Tabla Articulos */}

              <Row>
                <Col md={2}>
                  <Label className="mr-sm-2">Articulos</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Unidad</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Colores</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Cantidad</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">CBM</Label>
                </Col>
                <Col md={1}>
                  <Label className="mr-sm-2">Precio</Label>
                </Col>
                <Col md={2}>
                  <Label className="mr-sm-2">Total</Label>
                </Col>
              </Row>

              {inputFields.map((inputField) => (
                <div key={inputField.id}>
                  <Row>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="articulos"
                        type="select"
                        value={inputField.articulos}
                        required
                        onChange={(event)=>{BuscaArticulo(inputField.id, event)}}
                      >
                        <option value="">Selecciona un Articulo</option>
                        {articulos
                          .sort((a, b) => (a.codigo > b.codigo ? 1 : -1))
                          .map((a) => {
                            return (
                              <option value={a._id}>
                                {a.codigo} {a.nombre}
                              </option>
                            );
                          })}
                      </Input>
                    </Col>
                    <Col md={1}>
                        <Input
                         bsSize="sm"
                          name="unidad"
                          type="string"
                          value={inputField.unidad}
                          disabled
                        >
                        </Input>
                      </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="colores"
                        type="select"
                        value={inputField.colores}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      >
                        <option value="">Selecciona un Color</option>
                        {/* {inputField.arrayColoresArticulo */}
                        {colores
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => {
                            return <option value={a._id}>{a.name}</option>;
                          })}
                      </Input>
                    </Col>

                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="cantidad"
                        type="number"
                        placeholder="Cantidad"
                        value={inputField.cantidad}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>


                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="CBM"
                        type="number"
                        placeholder="CBM"
                        value={inputField.CBM}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>

                    <Col md={1}>
                      <Input
                        bsSize="sm"
                        name="precio"
                        type="number"
                        placeholder="Precio"
                        value={inputField.precio}
                        required
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col md={2}>
                      <Input
                        bsSize="sm"
                        name="total"
                        type="number"
                        placeholder="Total"
                        value={inputField.total}
                        disabled
                        onChange={(event) =>
                          handleChangeInput(inputField.id, event)
                        }
                      />
                    </Col>
                    <Col>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        disabled={inputFields.length === 1}
                        onClick={() => handleRemoveFields(inputField.id)}
                        tabindex="-1"
                      >
                        <i class="fas fa-minus"></i>
                      </Button>
                      <Button 
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1">
                      <i class="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              ))}
              <Row>
              <Col md={10}>
              <h4 id="logoutBoton">
              TOTALES {total_kilos} kg. / {total_metros} mts. / {"$" + new Intl.NumberFormat("en-US").format(total_general)}
              </h4>
              </Col>
              </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoOrdenesCompraInt"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCompraCreateInt;
